import React from 'react';
import styles from './AiAssistantOverlayButton.module.css';

interface Props {
  organizationId: string;
  aiAssistantId: string;
  aiAssistantAvatarUrl?: string;
}

const AiAssistantOverlayButton = ({
  organizationId,
  aiAssistantId,
  aiAssistantAvatarUrl,
}: Props) => {
  const handleClick = () => {
    const url = `${window.location.origin}/${organizationId}/ai_assistant/${aiAssistantId}`;
    window.open(url, '_blank');
  };

  return (
    <button
      className={styles.AiAssistantOverlayButton}
      onClick={handleClick}
      title="AI Assistant">
      {aiAssistantAvatarUrl ? (
        <img
          src={aiAssistantAvatarUrl}
          alt="AI Assistant"
          className={styles.AvatarImage}
        />
      ) : (
        <span className={`icon-ai_assistant_ic ${styles.DefaultIcon}`} />
      )}
    </button>
  );
};

export default AiAssistantOverlayButton;
